module.exports = __webpack_public_path__ + "static/Jamie-448be341476dc92cbd40ed7fc402537c.png";